import * as _4 from 'lodash4';
import { ISchedulerAvailableTerm } from '../interfaces/scheduler_available_term';

export class SchedulerAvailableTerm implements ISchedulerAvailableTerm {
  static build(sectionLabel: ISchedulerAvailableTerm) {
    return new SchedulerAvailableTerm(sectionLabel);
  }
  id: number;
  name: string;
  is_standalone_scheduler_default_term: boolean;

  constructor(sectionLabel: ISchedulerAvailableTerm) {
    _4.merge(this, sectionLabel);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/builders/scheduler_available_item.ts